import React from "react";
import "./WorkHistoryItem.scss";

import Button from "components/Button";

const WorkHistoryItem = ({
  position,
  organization,
  location,
  index,
  handleClickDelete
}) => {
  return (
    <div className="WorkHistoryItem">
      <div className="content">
        <div className="Position">{position}</div>
        <div className="Organization">{organization}</div>
        <div className="Location">{location}</div>
      </div>
      <Button onClick={handleClickDelete} index={index} type="primary">
        Delete
      </Button>
    </div>
  );
};

export default WorkHistoryItem;
